import(/* webpackMode: "eager", webpackExports: ["EmailLinkErrorCode","EmailLinkErrorCodeStatus","isClerkRuntimeError","isEmailLinkError","isKnownError","isMetamaskError","isReverificationCancelledError"] */ "/vercel/path0/node_modules/@clerk/nextjs/dist/esm/client-boundary/hooks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogIdentify"] */ "/vercel/path0/src/app/components/postHogIdentifyWrapper/PostHogIdentify.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TriplePixel"] */ "/vercel/path0/src/app/components/triplePixel/TriplePixel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StaleTabBanner"] */ "/vercel/path0/src/components/banners/StaleTabBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieSettingsButton"] */ "/vercel/path0/src/components/footer/CookieSettingsButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Menu"] */ "/vercel/path0/src/components/headerMarketing/Menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SignInButton"] */ "/vercel/path0/src/components/SignInButton.tsx");
